export default "__VITE_ASSET__Bud_27fO__"